import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useLang } from "@/context/LanguageContext";
import { subscribeNewsletter } from "@/lib/api";
import { ext } from "@/lib/ext";

const Footer = () => {
  const { lang, t } = useLang();
  const e = ext[lang];
  const [email, setEmail] = useState("");

  const subscribe = async (ev) => {
    ev.preventDefault();
    if (!email.includes("@")) return;
    try { await subscribeNewsletter(email); toast.success(e.subscribed); setEmail(""); }
    catch { toast.error("Error"); }
  };

  return (
    <footer className="border-t border-border bg-white" data-testid="site-footer">
      <div className="grid grid-cols-1 gap-6 px-4 py-8 sm:grid-cols-3 sm:px-6">
        <div>
          <img src="/logo.png" alt="LAINER" className="h-5 w-auto" />
        </div>
        <div className="flex flex-col gap-2">
          <Link to="/shop" className="font-mono text-[11px] uppercase tracking-widest hover:opacity-60">{t.nav.shop}</Link>
          <Link to="/track" className="font-mono text-[11px] uppercase tracking-widest hover:opacity-60">{e.track}</Link>
          <Link to="/about" className="font-mono text-[11px] uppercase tracking-widest hover:opacity-60">{e.about}</Link>
          <Link to="/faq" className="font-mono text-[11px] uppercase tracking-widest hover:opacity-60">{e.faq}</Link>
          <Link to="/legal/termeni" className="font-mono text-[11px] uppercase tracking-widest hover:opacity-60">{lang === "ro" ? "Termeni" : "Terms"}</Link>
          <Link to="/legal/retur" className="font-mono text-[11px] uppercase tracking-widest hover:opacity-60">{lang === "ro" ? "Retur" : "Returns"}</Link>
          <Link to="/legal/confidentialitate" className="font-mono text-[11px] uppercase tracking-widest hover:opacity-60">{lang === "ro" ? "Confidențialitate" : "Privacy"}</Link>
          <a href="https://www.instagram.com/lainer.co/" target="_blank" rel="noreferrer" className="font-mono text-[11px] uppercase tracking-widest hover:opacity-60">Instagram</a>
        </div>
        <div>
          <div className="mb-2 font-mono text-[11px] uppercase tracking-widest text-muted-foreground">{t.footer.newsletter}</div>
          <form className="flex border border-border" onSubmit={subscribe}>
            <input type="email" value={email} onChange={(ev) => setEmail(ev.target.value)} placeholder={t.footer.emailPlaceholder} data-testid="newsletter-input"
              className="w-full bg-transparent px-3 py-2.5 font-mono text-[11px] uppercase tracking-widest placeholder:text-muted-foreground focus:outline-none" />
            <button type="submit" data-testid="newsletter-submit" className="bg-foreground px-4 font-mono text-[11px] text-white">→</button>
          </form>
        </div>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-4 border-t border-border px-4 py-5 sm:px-6" data-testid="anpc-badges">
        <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="nofollow noreferrer" aria-label="ANPC SAL — Soluționarea Alternativă a Litigiilor" data-testid="anpc-sal">
          <img src="/anpc-sal.svg" alt="ANPC — Soluționarea Alternativă a Litigiilor" className="h-[50px] w-[250px] object-contain" />
        </a>
      </div>
      <div className="flex flex-col items-center justify-between gap-2 border-t border-border px-4 py-4 font-mono text-[10px] uppercase tracking-widest text-muted-foreground sm:flex-row sm:px-6">
        <span>© {new Date().getFullYear()} LAINER · {t.footer.rights}</span>
        <a href="https://www.instagram.com/lainer.co/" target="_blank" rel="noreferrer" className="hover:text-foreground" data-testid="made-by">MADE BY SOLSTEF</a>
      </div>
    </footer>
  );
};

export default Footer;
